import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Container, Typography, Card, CardContent, TextField, Button, Box,
  Alert, Divider
} from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';

export default function MockPortalPage() {
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('return') || '/subscriptions';
  const customerId = searchParams.get('customer');

  const [cardLast4, setCardLast4] = useState('4242');
  const [saved, setSaved] = useState(false);

  function handleSave() {
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <CreditCardIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
        <Typography variant="h5" sx={{ mt: 1 }}>Mock Customer Portal</Typography>
        <Typography variant="body2" color="text.secondary">
          Development mode — manage your mock payment method
        </Typography>
      </Box>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>Current Payment Method</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, p: 1.5, bgcolor: 'grey.50', borderRadius: 1 }}>
            <CreditCardIcon color="action" />
            <Typography>Visa ending in {cardLast4}</Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" gutterBottom>Update Card</Typography>
          <TextField
            fullWidth
            label="New Card Number"
            placeholder="4242 4242 4242 4242"
            sx={{ mb: 2 }}
            onChange={(e) => {
              const digits = e.target.value.replace(/\D/g, '');
              if (digits.length >= 4) setCardLast4(digits.slice(-4));
            }}
          />
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField label="Exp" placeholder="MM/YY" size="small" sx={{ flex: 1 }} />
            <TextField label="CVC" placeholder="123" size="small" sx={{ flex: 1 }} />
          </Box>

          {saved && <Alert severity="success" sx={{ mb: 2 }}>Payment method updated!</Alert>}

          <Button fullWidth variant="contained" onClick={handleSave}>
            Update Payment Method
          </Button>
        </CardContent>
      </Card>

      <Button fullWidth variant="outlined" href={decodeURIComponent(returnUrl)}>
        Return to Billing
      </Button>

      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2, textAlign: 'center' }}>
        Mock portal for development. Customer: {customerId || 'unknown'}
      </Typography>
    </Container>
  );
}
